<template>
  <div class="invoice-manager">
    <!--<NavBar :token="token" />-->
    <div class="container">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                </span>
                    Gestione Fatture        
            </div>
        </div>    
      <!-- Upload Section -->
      <div class="upload-section">
        <input 
            type="file" 
            ref="fileInput" 
            @change="handleFileUpload" 
            accept=".pdf,image/*" 
            style="display: none" 
        />
        <input 
            type="file" 
            ref="cameraInput" 
            @change="handleFileUpload" 
            accept="image/*" 
            capture="environment" 
            style="display: none" 
        />

        <div class="mobile-upload-grid">
            <div class="upload-card camera" @click="$refs.cameraInput.click()">
                <div class="card-icon">📸</div>
                <div class="card-text">Scatta Foto</div>
            </div>
            <div class="upload-card gallery" @click="$refs.fileInput.click()">
                <div class="card-icon">📁</div>
                <div class="card-text">Gallery / PDF</div>
            </div>
        </div>

        <div v-if="uploading" class="upload-overlay">
            <div class="spinner-container">
                <div class="custom-spinner"></div>
                <p>Caricamento in corso...</p>
            </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="filters">
        <label>Da: <input type="date" v-model="startDate" /></label>
        <label>A: <input type="date" v-model="endDate" /></label>
        <div class="search-box">
            <input type="text" v-model="productSearchQuery" placeholder="Cerca per prodotto (nome o codice)..." class="form-control filter-input" />
        </div>
      </div>

      <!-- Invoices List -->
      <div class="invoices-list" id="style-3">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Partner</th>
              <th>Prodotti</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in filteredInvoices" :key="invoice._id">
              <td>{{ formatDate(invoice.created_at) }}</td>
              <td>{{ invoice.partner_id ? invoice.partner_id.nome : 'N/D' }}</td>
              <td>
                <span v-if="invoice.stato === 'PENDING'" class="badge badge-warning">Elaborazione...</span>
                <span v-else-if="invoice.stato === 'PROCESSED'" class="badge badge-info">Da Riconciliare</span>
                <span v-else-if="invoice.stato === 'COMPLETED'" class="badge badge-success">Completata</span>
                <span v-else>{{ invoice.prodotti ? invoice.prodotti.length : 0 }}</span>
              </td>
              <td>
                <button 
                    class="btn btn-info btn-sm" 
                    @click="viewInvoice(invoice)" 
                    :disabled="invoice.stato === 'PENDING'"
                >
                    {{ invoice.stato === 'PROCESSED' ? 'Riconcilia' : 'Dettagli' }}
                </button>
                <button 
                    class="btn btn-danger btn-sm ml-1" 
                    @click="deleteInvoice(invoice._id)"
                >
                    Elimina
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Details -->
      <div v-if="selectedInvoice" class="modal-overlay" @click.self="closeDetails">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Dettagli Fattura - {{ formatDate(selectedInvoice.created_at) }}</h3>
            <button @click="closeDetails" class="close-btn">&times;</button>
          </div>
          <div class="modal-body">
            <div class="invoice-image">
              <div class="header-with-btn">
                <h4>Partner (Fornitore)</h4>
              </div>
              <div class="partner-form">
                <div class="form-group">
                  <label>Nome:</label>
                  <input type="text" v-model="selectedInvoice.partner_id.nome" class="form-control" />
                </div>
                <div class="form-group">
                  <label>Partita IVA:</label>
                  <input type="text" v-model="selectedInvoice.partner_id.partita_iva" class="form-control" />
                </div>
                <div class="form-group group-row">
                  <div class="sub-group">
                    <label>Email:</label>
                    <input type="email" v-model="selectedInvoice.partner_id.email" class="form-control" />
                  </div>
                  <div class="sub-group">
                    <label>Telefono:</label>
                    <input type="text" v-model="selectedInvoice.partner_id.telefono" class="form-control" />
                  </div>
                </div>
                <button @click="updatePartnerInfo" class="btn btn-primary btn-sm mt-2">
                  {{ selectedInvoice.partner_id._id ? 'Aggiorna Dati Partner' : 'Aggiungi Dati Partner' }}
                </button>
              </div>

              <div class="header-with-btn mt-4">
                <h4>Visualizzazione File</h4>
                <button @click="openExternal(selectedInvoice.file_path)" class="btn btn-outline-primary btn-sm">Apri Esternamente</button>
              </div>
              <div class="file-container">
                <div v-if="!selectedInvoice.file_path" class="no-file">
                    <p>Nessun file collegato a questa fattura.</p>
                </div>
                <img :src="getInvoiceUrl(selectedInvoice.file_path)" alt="Fattura" v-else-if="isImage(selectedInvoice.file_path)" />
                <iframe :src="getInvoiceUrl(selectedInvoice.file_path)" width="100%" height="500px" v-else></iframe>
              </div>
            </div>
            <div class="invoice-products">
              <div class="header-with-btn">
                <h4>Prodotti Caricati</h4>
                <button 
                    v-if="selectedInvoice.stato === 'PROCESSED'" 
                    @click="confirmReconciliation" 
                    class="btn btn-success btn-sm"
                    :disabled="!isReadyToConfirm"
                >
                    Conferma Carico Massivo
                </button>
              </div>
              <div class="table-scroll" id="style-3">
                <table>
                  <thead>
                    <tr>
                      <th>Codice</th>
                      <th>Nome</th>
                      <th>Quantità</th>
                      <th>Prezzo (€)</th>
                      <th>Associa a Mappa</th>
                      <th v-if="selectedInvoice.stato === 'COMPLETED'">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(prod, index) in selectedInvoice.prodotti" :key="index">
                      <td>
                        <input v-if="prod.matchedCode === 'NEW'" type="text" v-model="prod.code" class="form-control" />
                        <span v-else>{{ prod.code }}</span>
                      </td>
                      <td><input type="text" v-model="prod.nome" class="form-control" /></td>
                      <td><input type="number" v-model="prod.quantita" class="form-control" /></td>
                      <td><input type="number" step="0.01" v-model="prod.prezzo" class="form-control" /></td>
                      <td>
                        <select v-model="prod.matchedCode" class="form-control">
                            <option :value="null">-- Non associare --</option>
                            <option value="NEW">-- Crea Nuovo Prodotto --</option>
                            <option v-for="p in tuttiProdottiMappati" :key="p.code" :value="p.code">
                                {{ p.descrizio }} ({{ p.code }})
                            </option>
                        </select>
                      </td>
                      <td v-if="selectedInvoice.stato === 'COMPLETED'">
                        <button @click="updateProduct(prod)" class="btn btn-success btn-sm">Salva</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { store } from '../store/store.js'

export default {
  name: 'InvoiceManager',
  data() {
    return {
      token: '',
      store,
      invoices: [],
      tuttiProdottiMappati: [],
      selectedFile: null,
      uploading: false,
      selectedInvoice: null,
      pollingInterval: null,
      productSearchQuery: ''
    }
  },

  watch: {
    invoices: {
        handler(newVal) {
            const hasPending = newVal.some(i => i.stato === 'PENDING' || i.stato === 'PROCESSED');
            if (hasPending && !this.pollingInterval) {
                this.startPolling();
            } else if (!hasPending && this.pollingInterval) {
                this.stopPolling();
            }
        },
        deep: true
    }
  },

  computed: {
    filteredInvoices() {
      return this.invoices.filter(invoice => {
        // Show completed, processed (ready to reconcile), or error invoices
        // Hide PENDING to avoid clutter, as it's being polled anyway
        if (invoice.stato === 'PENDING') return false;

        const date = new Date(invoice.created_at);
        const start = this.startDate ? new Date(this.startDate) : null;
        const end = this.endDate ? new Date(this.endDate) : null;

        if (start && date < start) return false;
        if (end) {
            // Set end date to end of day
            end.setHours(23, 59, 59, 999);
            if (date > end) return false;
        }

        // Product search filter
        if (this.productSearchQuery) {
            const query = this.productSearchQuery.toLowerCase();
            const hasProduct = invoice.prodotti && invoice.prodotti.some(p => {
                const nome = (p.nome || '').toLowerCase();
                const code = (p.code || '').toLowerCase();
                return nome.includes(query) || code.includes(query);
            });
            if (!hasProduct) return false;
        }

        return true;
      });
    },
    isReadyToConfirm() {
        return this.selectedInvoice && 
               this.selectedInvoice.prodotti && 
               this.selectedInvoice.prodotti.some(p => p.matchedCode);
    }
  },
  mounted() {
    try {
      this.token = localStorage.token ? JSON.parse(localStorage.token) : '';
    } catch (e) {
      this.token = localStorage.token || '';
    }
    this.fetchInvoices();
    this.fetchMappa();
  },
  beforeUnmount() {
    this.stopPolling();
  },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.uploadInvoice();
      }
    },
    async fetchMappa() {
        try {
            const response = await this.axios.post(this.store.path+'displayProduct',{headers:{
                authorization: `Bearer ${this.token}`}});
            this.tuttiProdottiMappati = response.data.messaggio;
        } catch (error) {
            console.error('Fetch mappa error:', error);
        }
    },
    async uploadInvoice() {
      if (!this.selectedFile) return;

      this.uploading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        await this.axios.post(this.store.path + 'fattura/upload', formData, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });
        alert('Fattura caricata con successo! In elaborazione...');
        this.selectedFile = null;
        // Refresh list
        this.fetchInvoices();
      } catch (error) {
        console.error('Upload error:', error);
        alert('Errore durante il caricamento della fattura.');
      } finally {
        this.uploading = false;
      }
    },
    async fetchInvoices() {
      try {
        const response = await this.axios.get(this.store.path + 'fattura', {
            headers: {
                authorization: `Bearer ${this.token}`
            }
        });
        this.invoices = response.data;
      } catch (error) {
        console.error('Fetch error:', error);
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString();
    },
    viewInvoice(invoice) {
        const copy = JSON.parse(JSON.stringify(invoice));
        if (!copy.partner_id) {
            copy.partner_id = {
                _id: null,
                nome: '',
                partita_iva: '',
                email: '',
                telefono: ''
            };
        }
        
        // Auto-match products if not already matched
        if (copy.prodotti) {
            copy.prodotti = copy.prodotti.map(p => {
                const match = this.tuttiProdottiMappati.find(mp => mp.code === p.code);
                return {
                    ...p,
                    matchedCode: p.matchedCode || (match ? match.code : 'NEW')
                };
            });
        }

        this.selectedInvoice = copy;
    },
    async confirmReconciliation() {
        if (!this.selectedInvoice) return;

        const payload = {
            fatturaId: this.selectedInvoice._id,
            products: this.selectedInvoice.prodotti
                .filter(p => p.matchedCode)
                .map(p => {
                    return {
                        code: p.matchedCode === 'NEW' ? p.code : p.matchedCode,
                        isNew: p.matchedCode === 'NEW',
                        quantita: p.quantita,
                        prezzo: p.prezzo,
                        nome: p.nome
                    };
                })
        };

        try {
            await this.axios.post(this.store.path + 'fattura/confirm-load', payload, {
                headers: { authorization: `Bearer ${this.token}` }
            });
            alert('Prodotti caricati con successo!');
            this.selectedInvoice = null;
            this.fetchInvoices();
        } catch (error) {
            console.error('Confirm error:', error);
            alert('Errore durante il caricamento riconciliato.');
        }
    },
    closeDetails() {
        this.selectedInvoice = null;
    },
    getInvoiceUrl(filePath) {
        if (!filePath) return '';
        // Extract filename from absolute path
        const filename = filePath.split('/').pop();
        // The server serves the uploads directory at /uploads
        // Ensure store.path ends with / or root-like structure
        let baseUrl = this.store.path.replace('/login/', '/').replace('/login', '/');
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        return `${baseUrl}uploads/${filename}`;
    },
    isImage(filePath) {
        if (!filePath) return false;
        const ext = filePath.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'jfif', 'pjpeg', 'pjp'].includes(ext);
    },
    isPdf(filePath) {
        if (!filePath) return false;
        const ext = filePath.split('.').pop().toLowerCase();
        return ext === 'pdf';
    },
    openExternal(filePath) {
        window.open(this.getInvoiceUrl(filePath), '_blank');
    },
    async updateProduct(prod) {
        try {
            await this.axios.post(this.store.path + 'fattura/update-product', {
                fatturaId: this.selectedInvoice._id,
                code: prod.code,
                newQuantity: prod.quantita,
                newPrice: prod.prezzo,
                newName: prod.nome
            }, {
                headers: {
                    authorization: `Bearer ${this.token}`
                }
            });
            alert('Prodotto aggiornato con successo e allineato col magazzino!');
            // Refresh invoices to get updated data if needed, or just keep local state
            this.fetchInvoices();
        } catch (error) {
            console.error('Update error:', error);
            alert('Errore durante l\'aggiornamento del prodotto.');
        }
    },
    async deleteInvoice(id) {
        if (!confirm('Sei sicuro di voler eliminare questa fattura e tutti i prodotti associati?')) return;

        try {
            await this.axios.delete(this.store.path + 'fattura/' + id, {
                headers: { authorization: `Bearer ${this.token}` }
            });
            alert('Fattura eliminata con successo.');
            this.fetchInvoices();
        } catch (error) {
            console.error('Delete error:', error);
            alert('Errore durante l\'eliminazione della fattura.');
        }
    },
    async updatePartnerInfo() {
        if (!this.selectedInvoice) return;
        try {
            const partnerData = this.selectedInvoice.partner_id || {};
            const response = await this.axios.post(this.store.path + 'fattura/update-partner', {
                partnerId: partnerData._id || null,
                fatturaId: this.selectedInvoice._id,
                nome: partnerData.nome,
                partita_iva: partnerData.partita_iva,
                email: partnerData.email,
                telefono: partnerData.telefono
            }, {
                headers: { authorization: `Bearer ${this.token}` }
            });
            alert('Partner aggiornato con successo!');
            if (response.data && response.data.partner) {
                this.selectedInvoice.partner_id = response.data.partner;
            }
            this.fetchInvoices();
        } catch (error) {
            console.error('Update partner error:', error);
            alert('Errore durante l\'aggiornamento del partner.');
        }
    },
    startPolling() {
        if (this.pollingInterval) return;
        this.pollingInterval = setInterval(() => {
            this.fetchInvoices();
        }, 5000);
    },
    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.upload-section {
  margin-bottom: 25px;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

.mobile-upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s, background 0.3s;
  text-align: center;
}

.upload-card:active {
  transform: scale(0.95);
}

.upload-card.camera {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
}

.upload-card.gallery {
  background: linear-gradient(135deg, #17a2b8, #007bff);
  color: white;
}

.card-icon {
  font-size: 2.5em;
  margin-bottom: 8px;
}

.card-text {
  font-weight: bold;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Custom Spinner Overlay */
.upload-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.spinner-container {
  text-align: center;
}

.custom-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #28a745;
  border-radius: 50%;
  animation: rotate 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.filters {
  margin-bottom: 20px;
  gap: 20px;
  display: flex;
}

.invoices-list {
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 12px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

th {
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 10;
}

.badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.8em;
}

.badge-warning {
  background: #ffc107;
  color: #212529;
}

.badge-info {
  background: #17a2b8;
  color: white;
}

.badge-success {
  background: #28a745;
  color: white;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  width: 90%;
  max-width: 1100px;
  max-height: 90vh;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  padding: 15px 20px;
  background: #343a40;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 768px) {
  .modal-body {
    grid-template-columns: 1fr;
  }
}

.invoice-image h4, .invoice-products h4 {
  margin: 0;
}

.header-with-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 2px solid #eee;
}

.no-file {
    padding: 40px;
    text-align: center;
    color: #666;
}

.file-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  background: #f0f0f0;
}

.file-container img {
  max-width: 100%;
  height: auto;
}

.partner-form {
  background: #fdfdfd;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  font-weight: bold;
  font-size: 0.9em;
  margin-bottom: 3px;
}

.group-row {
  display: flex;
  gap: 10px;
}

.sub-group {
  flex: 1;
}

.mt-2 { margin-top: 10px; }
.mt-4 { margin-top: 20px; }

.table-scroll {
  max-height: 500px;
  overflow-y: auto;
}

.form-control {
  padding: 5px;
  width: 100%;
  box-sizing: border-box;
}

/* Scrollbar styling */
#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}
</style>

